/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import UnifiedNav from 'components/common/header/UnifiedNav';
import { MinimalFooter } from '@zola/zola-ui';
import { browserHistory } from 'react-router';
import { getQueryParam } from '../../util/storage';

const { EVENTS: { OPEN_MODAL_EVENT, MODAL_TYPE_AUTH, NAV_LOADED } } = NAV_DATA;

const helmetStyle = [{
  type: 'text/css',
  cssText: ` html, .main-content {
    background: #FCFCFC;
  }
  body {
    margin-bottom: 75px;
  }`
}];

const modalStyleOverride = {
  top: '100px',
  boxShadow: 'none',
  paddingBottom: '120px'
};

// Login that renders full page variation of web-nav login modal
const LoginV2  = ({ location }) => {
  const { pathname, state } = location || {};

  const getCustomEventDetail = () => {
    const referralPage = (state && state.referralPage) ? state.referralPage : '';
    const weddingLoginCallback = (hasWeddingAccount, hasRegistry) => {
      if (hasWeddingAccount) {
        if (referralPage) {
          window.location.href = referralPage;
        } else {
          browserHistory.push('/wedding/manage');
        }
      } else if (hasRegistry) {
        browserHistory.push('/wedding/from-registry');
      } else {
        browserHistory.push('/wedding/onboard?product=WEDDING_WEBSITE');
      }
    }
    const weddingSignupLinkCallback = () => {
      window.location.href = '/onboard/select-product';
    }

    const authLoginCallback = () => {
      const encodedReturnPath = getQueryParam('returnTo', true)

      // If a returnTo path is provided with a relative path, redirect there
      // Else go to the homepage for the normal redirect logic
      const returnToPath = decodeURIComponent(encodedReturnPath);
      if (/^\//.test(returnToPath)) {
        window.location.href = returnToPath;
      } else {
        window.location.href = '/';
      }
    }

    const modalOptions = {
      size: 'sm',
      ariaLabel: 'Login',
      styleOverride: modalStyleOverride
    };
    switch (pathname) {
      case '/wedding/login': // deprecated src/pages/Login
        return {
          type: MODAL_TYPE_AUTH,
          modalProps: {
            hideClose: true,
            isFullPage: true,
            loginCallback: weddingLoginCallback,
            signupLinkCallback: weddingSignupLinkCallback
          },
          modalOptions
        }
      case '/onboard/login': // deprecated src/pages/preauth/LoginPageContainer
        return {
          type: MODAL_TYPE_AUTH,
          modalProps: {
            hideClose: true,
            isFullPage: true,
            signupLinkCallback: weddingSignupLinkCallback // loginCallback same as default web-nav; return to homepage
          },
          modalOptions
        };
      case '/account/login': // deprecated web-zola page
      default: // default behavior follows default web-nav AuthModal login flow
        return {
          type: MODAL_TYPE_AUTH,
          modalProps: {
            hideClose: true,
            isFullPage: true,
            loginCallback: authLoginCallback
          },
          modalOptions
        };
    }
  };

  useEffect(() => {
    const handleInitNavData = () => {
      const detail = getCustomEventDetail();
      window.dispatchEvent(new CustomEvent(OPEN_MODAL_EVENT, { detail }));
    };

    window.addEventListener(NAV_LOADED, handleInitNavData);
    return () => {
      window.removeEventListener(NAV_LOADED, handleInitNavData);
    };
  }, []);

  return (
    <div>
      <Helmet
        style={helmetStyle}
      />
      <header className="minimal-header">
        <a href="/" target="_self">
          <div className="zola-logo-horizontal-black center-block" />
        </a>
      </header>
      <UnifiedNav isHidden/>
      <MinimalFooter />
    </div>
  );
};

LoginV2.propTypes = {
  location: PropTypes.shape({})
};

export default LoginV2;



// WEBPACK FOOTER //
// ./src/pages/LoginV2/LoginV2.jsx